import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { NotificationManager } from 'react-notifications';

// Services
import productsService from "@services/products";

// Components
import POSStructure from '@components/POSStructure'
import Cards from '@components/Cards'
import paginator from '@utils/paginator'

import UserContext from '@components/context/userContext';

import { EventBus as eventBus } from "@components/EventBus";

class Page extends Component {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            pagination: {
                left: {
                    first: {
                        click: () => this.setState({ page: 1 }),
                        show: true,
                    },
                    previous: {
                        click: () => this.setState({ page: this.state.page - 1 }),
                        show: true,
                    }
                },
                right: {
                    next: {
                        click: () => this.setState({ page: this.state.page + 1 }),
                        show: true,
                    },
                    last: {
                        click: () => this.setState({ page: this.state.lastPage }),
                        show: true,
                    }
                }
            },
            goBack: () => '/pos/ticket',
            title: 'Produtos',
            filters: [{
                label: 'Nome',
                field: 'nome',
                value: '',
                placeholder: 'Pesquise pelo Nome',
                handleChange: (e) => this.handleChange(e),
            }, {
                label: 'ID',
                field: 'idproduct',
                value: '',
                placeholder: 'Pesquise pelo ID',
                handleChange: (e) => this.handleChange(e),
            }],
            items: [],
            page: 1,
            lastPage: 0,
            pageSize: 24,
            loaded: false,
        };

        this.loadFunction = this.loadFunction.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.setState({ filters: this.state.filters.map((filter) => {
            return {
                ...filter,
                value: e.target.name === filter.field ? e.target.value : filter.value,
            }
        }) });
    }

    async loadFunction() {
        const profile = this.context;

        if (!this.state.loaded) {
            try {
                const products = await productsService.getWithFilter(profile.idEmpresa, { combustivel: true });

                const enrichedProducts = products.map((product) => ({
                        ...product,
                        icon: 'fa-box',
                        text: product.nome || product.idproduct,
                        click: () => eventBus.$emit("SET/steps/form", { product }),
                }));

                const lastPage = Math.ceil(enrichedProducts.length / this.state.pageSize);
                this.setState({ items: enrichedProducts, lastPage, loaded: true });
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                NotificationManager.error('Erro ao carregar produtos', 'Produtos');
            }
        }
    }
    
    render () {
        const { items, title, filters, goBack, pagination, page, pageSize } = this.state;
        const filteredItems = items.filter((item) => {
            return filters
                .every((filter) =>
                    filter.value
                    ? filter.value.split(' ')
                        .every((filterValue) => 
                            (item[filter.field] || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                                .includes(filterValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                        )
                    : true
                );
        });
        const pageInfo = paginator(filteredItems, page, pageSize);

        const realPagination = {
            left: pageInfo.pre_page ? pagination.left : { first: {}, previous: {} },
            right: pageInfo.next_page ? pagination.right : { next: {}, last: {} },
        }

        return (
            <>
                <POSStructure
                    {...this.props}
                    title={ pageInfo.total ? `${title} (${pageInfo.total})` : title }
                    pagination={ realPagination }
                    goBack={ goBack }
                    filters={ filters }
                    loadFunction={ this.loadFunction }
                >
                    <Cards modifier="small" items={ pageInfo.data } />
                </POSStructure>
            </>
        );
    }
}

export default withCookies(Page);